import ajax from "@/utils/ajax.js";

export default {
    async getWechatTicketTypeInfoAsync(input) {
      let r = await ajax.post("/ticketType/GetWechatTicketTypeInfoAsync", input);
      return r.result;
    },
    async getWechatGroundChangCisAsync(input) {
      let r = await ajax.post("/ticketType/GetWechatGroundChangCisAsync", input);
      return r.result;
    }
  };